<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'

    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import AUTH from '@/views/mis/util/auth'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    const requestOptions = {
	    headers: {"Content-Type": "application/json"},
        responseType: "blob",
    }

    let originalTableData = [];

    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    if(data.timeRange != undefined && data.timeRange.length > 0) {
                        let { timeRangeStart, timeRangeEnd, timeRange, ...rest } = data;
                        this.queryData = rest;
                        this.queryData.fromTime = DateUtil.formatDate(timeRangeStart, "yyyy-MM-dd hh:mm:ss");
                        this.queryData.toTime = DateUtil.formatDate(timeRangeEnd, "yyyy-MM-dd hh:mm:ss");
                    } else {
                        this.queryData = data;
                    }
                    console.log("queryData", this.queryData);
                    this.$refs.childTable.defaultQueryData(this.queryData);
                } else if(window.$t('mis.bt.export') == clickName) {
                    this.confirmAction(clickName, "export");
                } else if(window.$t('mis.bt.down') == clickName) {
                    this.confirmAction(clickName, "download");
                }
            },
            confirmAction(clickName, action) {
                this.$confirm(window.$t('mis.lp.confirmDownload'), window.$t('mis.lp.confirmMessageTitle'), {
                confirmButtonText: window.$t('mis.lp.confirmButton'),
                cancelButtonText: window.$t('mis.lp.cancleButton'),
                type: 'warning'
                }).then(() => {
                    this.requestExcel(action);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: window.$t('mis.lp.cancleMessage') + clickName
                    });          
                });
            },
            requestExcel(action) {
                let url = URL.lp.download;
                if("export" == action) {
                    url = URL.lp.export;
                }
                let {pageSize, pageNum, ...params} = this.queryData;
                this.$axios.post(url, JSON.stringify(params), requestOptions).then((res) => {
                    const data = res.data == null ? res : res.data;
                    const blob =new Blob([data], { type: 'application/vnd.ms-excel' });
                    
                    const href = window.URL.createObjectURL(blob);
                    
                    const anchorElement = document.createElement('a');
                    
                    anchorElement.href = href;

                    // 1) Get the value of content-disposition header
                    const contentDisposition = res.headers == null ? "" : res.headers['Content-Disposition'];
                    // console.log('contentDisposition: ', contentDisposition);

                    // 2) set the fileName variable to the default value
                    let fileName = "lp_"+action+"_excel_"+ Date.now() +".xlsx";

                    // 3) if the header is set, extract the filename
                    if (contentDisposition) {
                        const fileNameMatch =
                        contentDisposition.match(/filename="(.+)"/);
                        // console.log('fileNameMatch', fileNameMatch);
                        if (fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                        }
                    }

                    anchorElement.download = fileName;

                    document.body.appendChild(anchorElement);
                    anchorElement.click();

                    document.body.removeChild(anchorElement);
                    window.URL.revokeObjectURL(href);    
                }).catch(err => {
                    console.error(err);
                })
            },
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      { title: window.$t('mis.lp.name'), field: 'name'},
                      { title: window.$t('mis.lp.phoneNumber'), field: 'phone'},
                      { title: window.$t('mis.lp.sourceUrl'), field: 'sourceUrl'},
                      { title: window.$t('mis.lp.createdTime'), field: 'timeRange', type: 6},
                      { click: window.$t('mis.bt.query')},
                      { click: window.$t('mis.bt.export'), auth: "mis:lp:export"},
                      { click: window.$t('mis.bt.down'), auth: "mis:lp:download"}
                  ]
                },
                /*table生成*/
                pageData: {
                    method: "post",
                    fieldTotal: "recordsFiltered",
                    fieldData: "data",
                    isShow: false,
                    queryUrl: URL.lp.query, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.lp.name'), field: 'name'},
                        { title: window.$t('mis.lp.phoneNumber'), field: 'phone'},
                        { title: window.$t('mis.lp.sourceUrl'), field: 'sourceUrl'},
                        { title: window.$t('mis.lp.createdTime'), field: 'createdTime'}
                    ]
                }
            }
        }
    }
</script>
